import { Button, Result } from "antd";
import { useLocation, useNavigate } from "react-router-dom";

const NotAuthorized = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Result
      status="403"
      title="Sorry you are not logged in"
      subTitle="you are not authorized to access this page."
      extra={
        <Button
          type="primary"
          className="h-12 px-8 border border-2 border-border text-base bg-primary text-white border-none"
          onClick={() => {
            console.log(location.state?.from);
            navigate("/login?redirectUrl=" + window.location.href);
          }}
        >
          Login
        </Button>
      }
    />
  );
};

export default NotAuthorized;
